import React from "react"
import FormControl from "@material-ui/core/FormControl"
import MenuItem from "@material-ui/core/MenuItem"
import Select from "@material-ui/core/Select"
import { makeStyles } from "@material-ui/core/styles"
import PropTypes from "prop-types"
import FlagIcon from "../FlagIcon"

export const supportedLocales = {
  enUS: {
    name: "en",
    code: "us"
  },
  frFR: {
    name: "fr",
    code: "fr"
  }
}

const useStyles = makeStyles(() => ({
  formControl: {
    minWidth: 100,
    margin: "unset"
  },
  flagIcon: {
    marginRight: 10
  }
}))

function LocaleSelect({ onChange, value, ...others }) {
  const classes = useStyles()

  function onLocaleChange(event) {
    onChange(event.target.value)
  }

  return (
    <FormControl
      className={classes.formControl}
      variant="outlined"
      size="small"
      {...others}
    >
      <Select value={value} onChange={onLocaleChange}>
        {Object.values(supportedLocales).map((locale) => (
          <MenuItem key={locale.name} value={locale.name}>
            <FlagIcon
              className={`locale-button ${classes.flagIcon}`}
              code={locale.code}
            />
            {locale.name.toUpperCase()}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

LocaleSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOf(Object.values(supportedLocales).map((l) => l.name))
    .isRequired
}

export default LocaleSelect
